<template>
  <div id="menu" :class="{ open: isOpen }">
    <div id="head">
      <h1 id="nombreMob" v-if="mobile" :class="{ open: isOpen }">NR</h1>
      <h1 id="nombre" v-else :class="{ open: isOpen }">NICOLAS RIVERA</h1>
      <div id="hambu" :class="{ open: isOpen }" @click="open">
        <span class="top"></span>
        <span class="mid"></span>
        <span class="mid"></span>
        <span class="down"></span>
      </div>
    </div>
    <transition name="fade">
        <ul v-if="isOpen" class="list" :class="{ open: isOpen }">
            <!-- <router-link to="/">Home</router-link> |
            <router-link to="/about">About</router-link> | -->
            <li class="limenu">
                <a href="#about" @click="open">about</a>
                <!-- <router-link :to="{ name: 'counter' }">about</router-link> -->
            </li>
            <li class="limenu">
                <a href="#works" @click="open">works</a>
                <!-- <router-link :to="{ name: 'infos' }">infos</router-link> -->
            </li>
            <li class="limenu">
                <a href="#illus" @click="open">illustrations</a>
                <!-- <router-link :to="{ name: 'pokemon-search' }">illustrations</router-link> -->
            </li>  
            <li class="limenu">
                <a href="#contact" @click="open">contact</a>
                <!-- <router-link :to="{ name: 'slots' }">contact</router-link> -->
            </li>
            <!-- <router-link :to="{ name: 'todo' }">To Do</router-link> | -->
        </ul>
    </transition>
  </div>
</template>

<script>
export default {
    props: {
        mobile: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            isOpen: false,
            open: () => this.isOpen = !this.isOpen,
        }
    }
}
</script>
<style lang="scss" scoped>
#menu{
    // background-image: linear-gradient(rgba(255,255,255,1), rgba(255,255,255,0));
    // background-color: rgba(255,255,255,0.6);
    // background: linear-gradient(0deg,rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 100%);
    background: aqua;
    height: 70px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;
    -webkit-transition: .1s ease;
    -moz-transition: .1s ease;
    -o-transition: .1s ease;
    transition: .1s ease;
    mix-blend-mode: difference;
    // transition: color .2s, background-color .2s;
    @media screen and (max-width: 600px){
        background-color: rgba(255,255,255,1);
        height: 60px;
    }

    &.open{
        background: aqua;
        mix-blend-mode: unset;
        // background-color: rgba($color: var(--black), $alpha: 0.6);
        // background-image: linear-gradient(rgba(0,0,0,1), rgba(0,0,0,0));
    }
    .list{
        width: 100%;
        height: 0;
        // background-color: var(--black);
        background: aqua;
        padding: 10px;
        margin-top: 0px;
        position: fixed;
        top: 0px;
        -webkit-transition: .5s ease;
        -moz-transition: .5s ease;
        -o-transition: .5s ease;
        transition: .5s ease;

        .limenu{
            list-style: none;
            text-align: right;
            width: 100%;
            padding-right: 0px;
            margin-right: 0;
            cursor: pointer;
            // color: var(--black);
            -webkit-transition: .5s ease;
            -moz-transition: .5s ease;
            -o-transition: .5s ease;
            transition: .5s ease;

            @media screen and (max-width: 600px){
                margin: 10px auto;
                margin-right: 15px;
                text-align: right;
            }

            &:first-child{
                margin-top: 70px;
            }

            a{
                display: block;
                color: var(--white);
                text-decoration: none;
                margin: 0px;
                // margin-right: 50px;
                padding: 15px;
                padding-right: 115px;
                font-size: 1.8rem;
                font-weight: 400;
                letter-spacing: 5px;
                position: relative;
                -webkit-transition: .3s ease;
                -moz-transition: .3s ease;
                -o-transition: .3s ease;
                transition: .3s ease;
                @media screen and (max-width: 600px){
                    font-size: 1.5rem;
                    margin: 10px 40px;
                    padding-right: 25px;
                    text-align: right;
                }

                &:after{
                    content: '';
                    position: absolute;
                    right: 75px;
                    top: 30px;
                    height: 5px;
                    width: 30px;
                    background-color: var(--white);
                    -webkit-transition: .3s ease;
                    -moz-transition: .3s ease;
                    -o-transition: .3s ease;
                    transition: .3s ease;
                    @media screen and (max-width: 600px){
                        right: -20px;
                        height: 6px;
                        width: 30px;
                        top: 27px;
                    }
                }
                &:hover{
                    color: aqua;
                    background-color: var(--white);
                    
                    &:after{
                        background-color: aqua;
                    }
                }
            }

            &:hover{
                background: var(--white);
                color: aqua;
            }
        }

        &.open{
            -webkit-transition: .5s ease;
            -moz-transition: .5s ease;
            -o-transition: .5s ease;
            transition: .5s ease;
            height: 370px;
            &.fade-enter-active, &.fade-leave-active {
                -webkit-transition: .5s ease;
                -moz-transition: .5s ease;
                -o-transition: .5s ease;
                transition: .5s ease;
            }
            &.fade-enter {
                opacity: 1;
            }
            &.fade-leave-to {
                -webkit-transition: .5s ease;
                -moz-transition: .5s ease;
                -o-transition: .5s ease;
                transition: .5s ease;
                opacity: 0;
            }
        }
    }
    #head{
        width: 90%;
        display: flex;
        flex-flow: row nowrap;
        align-content: center;
        justify-content: space-between;
        margin: 5px 5% 20px;
        // mix-blend-mode: difference;
        @media screen and (max-width: 600px){
            margin: 10px 5%;
        }
        h1{
            letter-spacing: 10px;
            font-size: 2rem;
            color: var(--black);
            transition: all .35s ease;
            font-weight: 200;
            margin-left: 10px;
            z-index: 1000;
            @media screen and (max-width: 600px){
                margin: 0 0 0 10px;
                letter-spacing: 2.5px;
            }
            &.open{
                color: var(--white);
            }
        }
      
        #hambu{
            width: 35px;
            height: 35px;
            flex-flow: column nowrap;
            justify-content: space-evenly;
            align-self: center;
            position: relative;
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: .5s ease;
            -moz-transition: .5s ease;
            -o-transition: .5s ease;
            transition: .5s ease;
            cursor: pointer;
            z-index: 1000;
            margin-right: 10px;
            margin-top: 10px;
            mix-blend-mode: unset;
    
            @media screen and (max-width: 600px){
                margin-top: 5px;
            }
    
            span{
                display: block;
                position: absolute;
                height: 5px;
                width: 100%;
                background: var(--black);
                opacity: 1;
                left: 0;
                -webkit-transform: rotate(0deg);
                -moz-transform: rotate(0deg);
                -o-transform: rotate(0deg);
                transform: rotate(0deg);
                -webkit-transition: .3s ease;
                -moz-transition: .3s ease;
                -o-transition: .3s ease;
                transition: .3s ease;
    
                // @media screen and (max-width: 600px){
                //     height: 5px;
                // }
            }
            
            span:nth-child(1) {
                top: 0px;
                animation: mover 5s linear infinite;
                // animation-direction: alternate;
                // animation-iteration-count: 3;
            }
            span:nth-child(2), span:nth-child(3) {
                top: 10px;
                animation: mover2 5s linear infinite;
                // animation-direction: alternate;
                // animation-iteration-count: 3;
            }
            span:nth-child(4) {
                top: 20px;
                animation: mover3 5s linear infinite;
                // animation-direction: alternate;
                // animation-iteration-count: 3;
            }
            // @media screen and (max-width: 600px){
            //     span:nth-child(2), span:nth-child(3) {
            //         top: 10px;
            //     }
            //     span:nth-child(4) {
            //         top: 20px;
            //     }
            // }
    
            &.open{
                span:nth-child(1) {
                    top: 16px;
                    width: 0%;
                    left: 50%;
                    background: var(--white);
                    animation: none;
                }
                span:nth-child(2) {
                    -webkit-transform: rotate(45deg);
                    -moz-transform: rotate(45deg);
                    -o-transform: rotate(45deg);
                    transform: rotate(45deg);
                    background: var(--white);
                    animation: none;
                }
                span:nth-child(3) {
                    -webkit-transform: rotate(-45deg);
                    -moz-transform: rotate(-45deg);
                    -o-transform: rotate(-45deg);
                    transform: rotate(-45deg);
                    background: var(--white);
                    animation: none;
                }
                span:nth-child(4) {
                    top: 16px;
                    width: 0%;
                    left: 50%;
                    background: var(--black);
                    animation: none;
                }
                // &:hover{
                //     span{
                //         background: var(--white);
                //     }
                // }
            } 
        }
        @keyframes mover {
            0% {
                transform: translateX(1000px);
                opacity: 0.8;
            }
            10% {
                transform: translateX(0px);
            }
            13% {
                transform: translateX(10px);
            }
            16% {
                transform: translateX(0px);
            }
            97% {
                transform: translateX(0px);
                opacity: 0.8;
            }
            100% {
                opacity: 0;
            }
        }
        @keyframes mover2 {
            0% {
                transform: translateX(1000px);
                opacity: 0.3;
            }
            13% {
                transform: translateX(0px);
            }
            16% {
                transform: translateX(10px);
            }
            19% {
                transform: translateX(0px);
            }
            98% {
                opacity: 0.3;
                transform: translateX(0px);
            }
            100% {
                opacity: 0;
            }
        }
        @keyframes mover3 {
            0% {
                transform: translateX(1000px);
                opacity: 0.8;
            }
            16% {
                transform: translateX(0px);
            }
            19% {
                transform: translateX(10px);
            }
            22% {
                transform: translateX(0px);
            }
            99% {
                transform: translateX(0px);
                opacity: 0.8;
            }
            100% {
                opacity: 0;
            }
        }
    }
}
</style>